import { APP_HEADER_HEIGHT_VAR, HeaderContent, HEADER_TITLE_CLASS } from '../../../components/shell/app-header';

export default function FeuilletonEpisode2App() {
  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps/francais-college" backLabel="Français collège">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Feuilleton — épisode 2</h1>
          <p className="m-0 mt-0.5 text-[13px] leading-snug text-[color:var(--naia-text-secondary)]">
            Brouillon à valider — données fictives, rien n'est enregistré.
          </p>
        </div>
      </HeaderContent>
      <iframe
        src="/mini-apps/francais-college/episode_lexique.html"
        title="Feuilleton — épisode 2"
        className="w-full border-0"
        style={{ height: `calc(100dvh - var(${APP_HEADER_HEIGHT_VAR}, 0px))` }}
        sandbox="allow-scripts allow-downloads"
      />
    </>
  );
}
